import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";
import axAPI from "../../../api/axios-instance";
import { DataProvider } from "@refinedev/core";

type StadiumCapacityPayload = {
  teamFnlId: string;
  stadiumCapacity: number;
};

export const clubsStadiumCapacityDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    create: async ({ variables }) => {
      const url = "/cms/team/stadiumCapacity";
      try {
        const { data } = await httpClient.put(
          url,
          variables as StadiumCapacityPayload
        );
        return { data };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    update: async ({ variables }) => {
      const url = "/cms/team/stadiumCapacity";
      try {
        const { data } = await httpClient.put(
          url,
          variables as StadiumCapacityPayload
        );
        return { data };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
  };
